import * as React from 'react'
import * as Container from "../../container/container";

const Video = (key) => {
    return (
        <Container.Part background="beige" id="trailer" key={key}>
            <Container.Row>
                <div className="col-12">
                    <div className="inner-container">
                        <h2>Durch den Schlossgarten auf Herrenchiemsee mit Bürgermeister Armin Krämmer.</h2>
                        <figure className="video">
                            <div className="yt-container yt-enabled">
                                <Container.Video
                                    url={"/videos/Filmmaterial/010_Herrenchiemsee/210708_Herrenchiemsee mit Intro.mp4"}
                                    poster={"/images/Videowallpaper/herrenchiemsee.jpg"}/>
                            </div>
                        </figure>
                    </div>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default Video
